import tiktokAwards from "../../images/News/tiktokAwards.jpg";
import grammys1 from "../../images/News/grammys1.jpg";
import grammys2 from "../../images/News/grammys2.jpg";
import burningMan from "../../images/News/burningMan.jpg";
import rae from "../../images/News/rae.jpg";
import savage from "../../images/News/savage.jpg";

export const newsList = [
  {
    id: 5,
    foto: [tiktokAwards],
    text: [
      <p>
        <span>@tiktok Awards</span> at NeueHouse Hollywood and Livestream on the
        TikTok platform was a night to remember 🎉! Celebrating top TikTok
        creators, our team was proud to be a part of the audiovisual production
        that brought the event to life. From the stunning stage design to the
        crystal clear sound, it was a night that truly showcased the power of
        TikTok.
      </p>,
      <p>
        Congratulations to all TikTok Award winners, and a big thank you to
        everyone who made the event
      </p>,
    ],
    link: "https://www.linkedin.com/posts/1987masters_tiktok-awards-at-neuehouse-hollywood-and-activity-7091117291018326016-4mfG?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 4,
    foto: [grammys1, grammys2],
    text: [
      <p>
        <span>The Grammys</span> are always a whirlwind of celebration, and LA
        knows how to keep the party going. The previous years the festivities
        stretched over a week, packed with the hottest events in the industry.
      </p>,
      <p>
        We're thrilled to share a behind-the-scenes look at how we helped Sony
        Music throw an unforgettable bash. From planning to execution, we were
        part of the process that made their soiree the ultimate after-party
        destination.
      </p>,
      <p>And what a night it was!</p>,
      <p>The Grammys are about honoring the best in music, and</p>,
    ],
    link: "https://www.linkedin.com/posts/1987masters_grammys-sonymusicafterparty-eventplanning-activity-7218649313034330112-u8Ym?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 3,
    foto: [burningMan],
    text: [
      <p>
        Imagine a vast desert landscape transformed into a living, breathing
        work of art. Welcome to <span>Burning Man</span>, where the boundaries
        of imagination are pushed and creativity knows no limits.
      </p>,
    ],
    link: "https://www.linkedin.com/posts/1987masters_burningman-artinstallation-festivalvibes-activity-7216486837006008320-St6Z?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 2,
    foto: [savage],
    text: [
      <p>
        <span>Savage X Fenty Vol. 4</span>
      </p>,
      <p>
        At 1987 Masters, we believe in the power of events to transport
        attendees into new worlds. Our collaboration on the Savage X Fenty Vol.
        4 launch event was a prime example of this approach in action.
      </p>,
    ],
    link: "https://www.linkedin.com/posts/1987masters_tiktok-awards-at-neuehouse-hollywood-and-activity-7091117291018326016-4mfG?utm_source=share&utm_medium=member_desktop",
  },
  {
    id: 1,
    foto: [rae],
    text: [
      <p>Immerse yourself in the magic of SUNSET SOUNDS</p>,
      <p>
        NeueHouse bathed in golden hour glow, alive with the rhythms of an
        eclectic lineup of performers. This isn't typical concert series - it's
        a celebration of new sounds, a showcase of talent that leaves you
        mesmerized
      </p>,
      <p>
        We're excited to share a behind-the-scenes look at our work on the Raye
        live performance, a testament to the power of music and
      </p>,
    ],
    link: "https://www.linkedin.com/posts/1987masters_eventproduction-neuehousehollywood-sunsetsounds-activity-7203818063962525697-c0Sg?utm_source=share&utm_medium=member_desktop",
  },
];
